































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import RangeSlider from "@/components/VRangeSliderStyling.vue";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';

import * as def from '@/definitions'

import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { ColorConstruct } from '@/utilityModels/colorConstruct';
import { ExTextLayer } from '@/model/document2/page/surface/design/layer/exTextLayer';
import { MathHelper } from '@/helper/mathHelper';

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
      RangeSlider,
      ColorPicker,
      ColorSelector,
      AdjustedBalloon,
      ArrowDown,
      ArrowRight,
      CheckBoxOn
  },
})

// テキスト選択時, テキスト非選択時共通
// テキスト選択状態の場合は選択テキスト、非選択時は全テキストに適用する
export default class TextShadow extends Vue
{
    @Prop() private layer! : ExTextLayer;

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus()
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    // カーソル位置を元にしたtextInfo
    private get currentTextInfo()
    {
        var indexPair = this.layer.getLineAndCharacterIndexFromPosition(this.layer.startPosition);
        var info = this.layer.getCharacterInfo(indexPair.lineIndex, indexPair.characterIndex);
        return info != null ? info.textInfo : this.layer.baseTextInfo;
    }

    // startPosition -> endPositionのtextInfoの配列
    private get currentTextInfoArray()
    {
        var array = new Array();
        var start = Math.min(this.layer.startPosition, this.layer.endPosition);
        var end = Math.max(this.layer.startPosition, this.layer.endPosition);
        var indexArray = this.layer.getLineAndCharacterIndexArrayFromPositionRange(start, end);
        for(var indexPair of indexArray)
        {
            var info = this.layer.getCharacterInfo(indexPair.lineIndex, indexPair.characterIndex);
            var textInfo = info != null ? info.textInfo : this.layer.baseTextInfo;
            array.push(textInfo);
        }

        return array;
    }

    // 選択文字だけに変更を適用するか
    private isApplySelected()
    {
        // テキストが編集中であり、選択文字列があると選択文字のみに変更適用する
        return this.layer.inEdit && this.layer.startPosition != this.layer.endPosition;
    }

    private getCurrentValueInfo(propertyName)
    {
        // デフォルト値
        var defaultValue = this.layer.baseTextInfo[propertyName];
        // すべて値が同じフラグ
        var isSameAll = true;
        var value = defaultValue;

        var textInfoArray = this.isApplySelected() ? this.currentTextInfoArray : this.layer.textInfoArray;

        for(var i = 0; i < textInfoArray.length; ++i)
        {
            var textInfo = textInfoArray[i];
            var newValue = textInfo[propertyName];
            if(i > 0 && !MathHelper.equals(newValue, value))
            {
                isSameAll = false;
                value = defaultValue;
                break;
            }
            value = newValue;
        }

        return { value : value, isBlank : !isSameAll };
    }

    private getCurrentColorInfo(propertyName)
    {
        // デフォルト値
        var defaultValue = this.layer.baseTextInfo[propertyName];
        // すべて値が同じフラグ
        var isSameAll = true;
        var value = defaultValue;

        var textInfoArray = this.isApplySelected() ? this.currentTextInfoArray : this.layer.textInfoArray;

        for(var i = 0; i < textInfoArray.length; ++i)
        {
            var textInfo = textInfoArray[i];
            var newValue = textInfo[propertyName];
            if(i > 0 && !newValue.equals(value))
            {
                isSameAll = false;
                value = defaultValue;
                break;
            }
            value = newValue;
        }

        return { value : value, isBlank : !isSameAll };
    }

    private getPropertyValue(propertyName) { return this.getCurrentValueInfo(propertyName).value; }
    private getPropertyBlank(propertyName) { return this.getCurrentValueInfo(propertyName).isBlank; }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend : true
    };

    textShadowContentsOpenAnimate = false;
    textShadowContentsCloseAnimate = false;

    open(){
        if(this.openStatus.opend){
            this.textShadowContentsCloseAnimate = true;
            setTimeout(()=>{this.textShadowContentsCloseAnimate = false; this.textShadowContentsOpenAnimate = false; this.openStatus.opend = false;}, 200);
        }else{
            this.openStatus.opend = true;
            this.textShadowContentsOpenAnimate = true;
            setTimeout(()=>{this.textShadowContentsOpenAnimate = false;}, 250);
        }
    };
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    // 影
    private get isShadow()
    {
        var result = false;
        if(!this.isApplySelected() && this.layer.inEdit)
        {
            // 現在位置から取得
            result = this.currentTextInfo.isShadow;
        }
        else
        {
            // 選択中or非編集中の場合はすべてtrueの場合のみtrue
            var textInfoArray = this.isApplySelected() ? this.currentTextInfoArray : this.layer.textInfoArray;
            if(textInfoArray.length > 0)
            {
                var isExistFalse = false;
                for(var textInfo of textInfoArray)
                {
                    if(!textInfo.isShadow)
                    {
                        isExistFalse = true;
                        break;
                    }
                }
                if(!isExistFalse) { result = true; }
            }
            else
            {
                result = this.layer.baseTextInfo.isShadow;
            }
        }
        return result;
    }

    private isShadowChange()
    {
        this.changeTextInfo(!this.isShadow, "isShadow", true);
    }

    // 縁取り
    private get isOutline()
    {
        var result = false;
        if(!this.isApplySelected() && this.layer.inEdit)
        {
            // 現在位置から取得
            result = this.currentTextInfo.isOutline;
        }
        else
        {
            // 選択中or非編集中の場合はすべてtrueの場合のみtrue
            var textInfoArray = this.isApplySelected() ? this.currentTextInfoArray : this.layer.textInfoArray;
            if(textInfoArray.length > 0)
            {
                var isExistFalse = false;
                for(var textInfo of textInfoArray)
                {
                    if(!textInfo.isOutline)
                    {
                        isExistFalse = true;
                        break;
                    }
                }
                if(!isExistFalse) { result = true; }
            }
            else
            {
                result = this.layer.baseTextInfo.isOutline;
            }
        }
        return result;
    }

    private isOutlineChange()
    {
        this.changeTextInfo(!this.isOutline, "isOutline", true);
    }

    // スライダー
    private getSliderValue(propertyName)
    {
        var result = -99999;
        if(!this.isApplySelected() && this.layer.inEdit)
        {
            // 現在位置から取得
            result = this.currentTextInfo[propertyName];
        }
        else
        {
            // 選択中or非編集中の場合はすべての値から最大のものを表示する
            var textInfoArray = this.isApplySelected() ? this.currentTextInfoArray : this.layer.textInfoArray;
            if(textInfoArray.length > 0)
            {
                for(var textInfo of textInfoArray)
                {
                    result = Math.max(result, textInfo[propertyName]);
                }
            }
            else
            {
                result = this.layer.baseTextInfo[propertyName];
            }
        }
        return result;
    }

    // 影の距離
    private get shadowDistance() { return this.getSliderValue("shadowDistance"); }
    private get shadowDistanceDisplay() { return MathHelper.roundByDigits(this.shadowDistance).toFixed(); }
    private get shadowDistanceValue() { return this.shadowDistance; }
    private set shadowDistanceValue(value)
    {
        this.changeTextInfo(value, "shadowDistance", false);
    }
    private onChangeShadowDistance(value)
    {
        this.changeTextInfo(value, "shadowDistance", true);
    }

    // 影の角度
    private get shadowRotate() { return this.getSliderValue("shadowRotate"); }
    private get shadowRotateDisplay() { return MathHelper.roundByDigits(this.shadowRotate).toFixed(); }
    private get shadowRotateValue() { return this.shadowRotate; }
    private set shadowRotateValue(value)
    {
        this.changeTextInfo(value, "shadowRotate", false);
    }
    private onChangeShadowRotate(value)
    {
        this.changeTextInfo(value, "shadowRotate", true);
    }

    // 影のぼかし
    private get shadowBlur() { return this.getSliderValue("shadowBlur"); }
    private get shadowBlurDisplay() { return MathHelper.roundByDigits(this.shadowBlur, 1).toFixed(); }
    private get shadowBlurValue() { return this.shadowBlur; }
    private set shadowBlurValue(value)
    {
        this.changeTextInfo(value, "shadowBlur", false);
    }
    private onChangeShadowBlur(value)
    {
        this.changeTextInfo(value, "shadowBlur", true);
    }

    // 影の強さ
    private get shadowIntensity() { return this.getSliderValue("shadowIntensity"); }
    private get shadowIntensityDisplay() { return MathHelper.roundByDigits(this.shadowIntensity).toFixed(); }
    private get shadowIntensityValue() { return this.shadowIntensity; }
    private set shadowIntensityValue(value)
    {
        this.changeTextInfo(value, "shadowIntensity", false);
    }
    private onChangeShadowIntensity(value)
    {
        this.changeTextInfo(value, "shadowIntensity", true);
    }

    // 縁取りの太さ
    private get outlineThickness() { return this.getSliderValue("outlineThickness"); }
    private get outlineThicknessDisplay() { return MathHelper.roundByDigits(this.outlineThickness, 1).toFixed(); }
    private get outlineThicknessValue() { return this.outlineThickness; }
    private set outlineThicknessValue(value)
    {
        this.changeTextInfo(value, "outlineThickness", false);
    }
    private onChangeOutlineThickness(value)
    {
        this.changeTextInfo(value, "outlineThickness", true);
    }

    // 縁取りの強さ
    private get outlineIntensity() { return this.getSliderValue("outlineIntensity"); }
    private get outlineIntensityDisplay() { return MathHelper.roundByDigits(this.outlineIntensity).toFixed(); }
    private get outlineIntensityValue() { return this.outlineIntensity; }
    private set outlineIntensityValue(value)
    {
        this.changeTextInfo(value, "outlineIntensity", false);
    }
    private onChangeOutlineIntensity(value)
    {
        this.changeTextInfo(value, "outlineIntensity", true);
    }

    // 色

    // 影色
    private get shadowColor() { return this.layer.inEdit && !this.isApplySelected() ? this.currentTextInfo.shadowColor : this.getCurrentColorInfo("shadowColor").value; }
    private get shadowColorStyle()
    {
        var isBlank = this.layer.inEdit && !this.isApplySelected() ? false : this.getCurrentColorInfo("shadowColor").isBlank;
        return isBlank ? { "border-color" : "#000000", "border-width" : "1px", "border-style" : "solid" } : { "background-color" : this.shadowColor.hex };
    }

    private isShadowColorPickerVisible = false;
    private showShadowColorPicker()
    {
        this.isShadowColorPickerVisible = true;
    }
    private closeShadowColorPicker()
    {
        this.isShadowColorPickerVisible = false;
    }

    // 縁取り色
    private get outlineColor() { return this.layer.inEdit && !this.isApplySelected() ? this.currentTextInfo.outlineColor : this.getCurrentColorInfo("outlineColor").value; }

    private get outlineColorStyle()
    {
        var isBlank = this.layer.inEdit && !this.isApplySelected() ? false : this.getCurrentColorInfo("outlineColor").isBlank;
        return isBlank ? { "border-color" : "#000000", "border-width" : "1px", "border-style" : "solid" } : { "background-color" : this.outlineColor.hex };
    }

    private isOutlineColorPickerVisible = false;
    private showOutlineColorPicker()
    {
        this.isOutlineColorPickerVisible = true;
    }
    private closeOutlineColorPicker()
    {
        this.isOutlineColorPickerVisible = false;
    }

    // 色変更中
    private onChangingColor(color, tag)
    {
        this.changeTextInfo(color, tag, false);
    }

    // 色変更完了
    private onChangedColor(color, tag)
    {
        this.changeTextInfo(color, tag, true);
    }

    private changeTextInfo(value : any, propertyName : string, isFinish : boolean)
    {
        if(this.isApplySelected())
        {
            var textInfoArray = new Array();
            for(var textInfo of this.currentTextInfoArray)
            {
                // 文法の一部書き換え
                var newTextInfo = textInfo.clone();
                newTextInfo[propertyName] = value;
                textInfoArray.push(newTextInfo);
            }

            this.$emit("doCommand", "changePlainTextLayerRangeTextInfo", {
                layer : this.layer,
                textInfoArray : textInfoArray,
                startPosition : Math.min(this.layer.startPosition, this.layer.endPosition),
                endPosition : Math.max(this.layer.startPosition, this.layer.endPosition),
                isFinish : isFinish
            });
        }
        else
        {
            this.$emit("doCommand", "changePlainTextLayerWholeTextInfo", {
                layer : this.layer,
                propertyName : propertyName,
                value : value,
                isFinish : isFinish
            });
        }
    }

    private changeLayerProperty(propertyName : string, value : any)
    {
        this.$emit("doCommand", "changeLayerProperty", { layer : this.layer, propertyName : propertyName, value : value });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}



